import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { ListingPickerStoreContext } from '../contexts/StoreContext'
import { ListingPickerStore } from '../store/interface'

export const useListingPickerStore: UseStore<ListingPickerStore> = selector => {
  return useContextStore(ListingPickerStoreContext, selector)
}
